var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/arrow_backward/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M11.207 17.7929C11.5975 18.1834 11.5975 18.8166 11.207 19.2071C10.8164 19.5976 10.1833 19.5976 9.79274 19.2071L3.99985 13.4142C3.2188 12.6332 3.2188 11.3668 3.99985 10.5858L9.79274 4.79289C10.1833 4.40237 10.8164 4.40237 11.207 4.79289C11.5975 5.18342 11.5975 5.81658 11.207 6.20711L6.41406 11H20.4998C21.0521 11 21.4998 11.4477 21.4998 12C21.4998 12.5523 21.0521 13 20.4998 13H6.41406L11.207 17.7929Z",
    fill: "#6F767E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.61d17c709a2fa125ed2c4921ee5def37.svg";
export { ForwardRef as ReactComponent };